import React, { useCallback, useEffect, useState } from 'react';
import { IconStyled } from './Icon.styles';
const Icon = ({ name, size, color, ...props }) => {
    const [SVG, setSVG] = useState();
    const _importIcon = useCallback(({ name, size, }) => {
        if (!name)
            return setSVG(undefined);
        const optimized = Boolean(size);
        let fileName = `${name}`;
        if (optimized) {
            fileName = `${name}-${size}`;
        }
        import(
        /* webpackMode: "eager" */
        /* webpackPrefetch: true */
        /* webpackPreload: true */
        `../../icons/${fileName}.svg`).then((module) => setSVG(module.default({})))
            .catch((e) => {
            optimized ?
                _importIcon({ name })
                :
                    console.error(e);
        });
    }, // eslint-disable-next-line indent
    []);
    useEffect(() => {
        _importIcon({
            name,
            size,
        });
    }, // eslint-disable-next-line indent
    [name, size, _importIcon]);
    return (React.createElement(IconStyled, { name: name, size: size, color: color, "aria-hidden": true, ...props }, SVG));
};
export default Icon;
//# sourceMappingURL=Icon.js.map